import '../../../../../node_modules/@lit/reactive-element/reactive-element.js';
import '../../../../../node_modules/lit-html/lit-html.js';
import '../../../../../node_modules/lit-element/lit-element.js';
import { css as r } from '../../../../../node_modules/@lit/reactive-element/css-tag.js';

var css_248z = r`:host{display:flex}button.button-primary{align-items:center;align-self:stretch;background:linear-gradient(96deg,#702595,#aa0061);border:unset;border-radius:4px;cursor:pointer;font-family:Noto Sans,sans-serif;font-size:18px;font-style:normal;font-weight:700;justify-content:center;padding:12px 24px;width:100%}button.button-primary span{color:#fff}button.button-primary:hover{background:linear-gradient(96deg,rgba(112,37,149,.8),rgba(170,0,97,.8))}`;

export { css_248z as default };
